import { render, staticRenderFns } from "./ResponsiveLabel.vue?vue&type=template&id=06ffe456&scoped=true&"
import script from "./ResponsiveLabel.vue?vue&type=script&lang=js&"
export * from "./ResponsiveLabel.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveLabel.vue?vue&type=style&index=0&id=06ffe456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ffe456",
  null
  
)

export default component.exports